export enum WatchlistPopupType {
    GradeHistory = 1,
    MaturityHistory = 2,
    Issues = 3,
    FundingHistory = 4,
    EntityLoans = 5,
    LiquidityHistory = 6,
    AppraisalsHistory = 7,
}
